export default{

    welcomeBonus(state,data){
        state.welcomeBonus = data
    },

    referralBonus(state,data){
        state.referralBonus = data
    },

    equilibrumBonus(state,data){
        state.equilibrumBonus = data
    },

    loyaltyBonus(state,data){
        state.loyaltyBonus = data
    },

    profitPool(state,data){
        state.profitPool = data
    },

    profitPools(state,data){
        state.profitPools = data
    },

    globalProfit(state,data){
        state.globalProfit = data
    },

    globalProfits(state,data){
        state.globalProfits = data
    },

    placementBonus(state,data){
        state.placementBonus = data
    },

    totalBonus(state,data){
        state.totalBonus = data
    },

    walletBalance(state,data){
        state.walletBalance = data
    },

    totalEquilibrumBonus(state,data){
        state.totalEquilibrumBonus = data
    },

    totalLoyaltyBonus(state,data){
        state.totalLoyaltyBonus = data
    },

    totalProfitPoolBonus(state,data){
        state.totalProfitPoolBonus = data
    },

    totalGlobalProfitBonus(state,data){
        state.totalGlobalProfitBonus = data
    },

    countEquilibrumBonus(state,data){
        state.countEquilibrumBonus = data
    },

    countLoyaltyBonus(state,data){
        state.countLoyaltyBonus = data
    },

    countProfitPoolBonus(state,data){
        state.countProfitPoolBonus = data
    },

    countGlobalProfitBonus(state,data){
        state.countGlobalProfitBonus = data
    },

    companyWalletBalance(state,data){
        state.companyWalletBalance = data
    },

    totalCompanyWallet(state,data){
        state.totalCompanyWallet = data
    },

    bonusStats(state,data){
         state.bonusStats = data
    },

    userBonusStats(state,data){
        state.userBonusStats = data
    },

    // ✅ Add this right before the closing }
    SET_ALL_BONUSES(state, bonuses) {
        state.allBonuses = bonuses;
    }


}